ACC.worldpayLightbox = {
    savedCardHopEnabled:false,
    openLightbox: function () {
        var libraryObject = new WPCL.Library();
        libraryObject.setup(customOptions);
        $("#custom-trigger").click();
    },

    setUpCustomOptions: function (data) {
        customOptions["preferredPaymentMethod"] = $("input:radio[name=paymentMethod]:checked").val();
        customOptions["pendingURL"] = '';
        customOptions["failureURL"] = '';
        customOptions["errorURL"] = '';
        customOptions["cancelURL"] = '';
        customOptions["url"] = data.postUrl;
        customOptions["successURL"] = data.parameters.successURL;
        customOptions["resultCallback"] =
            function(responseData) {
                var redirectUrl;
                var status = responseData.order.status;
                switch (status) {
                case "success":
                    redirectUrl= data.parameters.successURL;
                    break;
                case "pending":
                    redirectUrl= data.parameters.pendingURL;
                    break;
                case "failure":
                    redirectUrl= data.parameters.failureURL;
                    break;
                case "error":
                    window.ACC.gtm.trackWorldPayErrorReturn(status);
                    redirectUrl= data.parameters.errorURL;
                    break;
                case "cancelled_by_shopper":
                    window.ACC.gtm.trackWorldPayIframeClosure(status);
                    redirectUrl= data.parameters.cancelURL;
                    break;
                default:
                    redirectUrl = data.parameters.errorURL;
                }
                window.location = redirectUrl;
            };
      },

    requestLigthboxConfiguration: function () {
        if ($("#globalMessages").children().length === 0 && $(".control-group.error").length === 0) {
            $.ajaxSetup({ cache: false });
            $.get(
                ACC.config.encodedContextPath + "/checkout/multi/worldpay/lightbox/payment-data",
                function (data) {
                    if (data.postUrl == null) {
                       /**
                        * If the response from the server contains an error, we hard
                        * refresh the page to allow the server to handle any re-directs.
                        */
                        window.location.reload(true);
                    } else {
                        $("#nextGenHopPlaceHolder").html(data);
                        ACC.worldpayLightbox.setUpCustomOptions(data);
                        ACC.worldpayLightbox.openLightbox();
                        ACC.gtm.trackWorldpayIframeGtmEventData();
                    }
                }
            );
        }
    },

    getGlobalErrors: function () {
        $.get(
            ACC.config.encodedContextPath + "/checkout/multi/worldpay/lightbox/check-global-errors",
            function (data) {
                $("#globalMessages").html(data);
                ACC.worldpayLightbox.requestLigthboxConfiguration();

                if (typeof window.reloadVueComponent === "function" && $("#globalMessages").length) {
                    window.reloadVueComponent($("#globalMessages")[0]);
                }
            }
        );
    },

    submitAjaxForm: function () {
        $(".wpBillingAddress").filter(":hidden").remove();
        ACC.worldpay.enableAddressForm();
        $.post(
            ACC.config.encodedContextPath + "/checkout/multi/worldpay/lightbox/add-payment-details",
            $("#worldPayBillingAddressForm").serialize(),
            function (data) {
                // TJX-4471 - This is timeout check, if it occurred it will not find the Url.
                // If timeout then redirect to login page
                if(data.indexOf("worldpay/redirect/add-payment-details") == -1){
                    window.location.reload();
                    return;
                }
                $("#wpPaymentDetailsFormPlaceHolder").html(data);
                ACC.worldpayLightbox.getGlobalErrors();
                ACC.worldpay.initForm();
                ACC.worldpayLightbox.initForm();
            }
        ).fail(function(jqXHR) {
            /**
             * If the response from the server is anything but 200 we hard
             * refresh the page to allow the server to handle any re-directs.
             */
            if (jqXHR.status !== 200) {
                window.location.reload();
            }
        });
    },

    bindSubmitPaymentAndBillingForm: function () {
        $(".paymentCta").click(function (event) {
            $('.paymentCta').attr('disabled', true);
            event.preventDefault();
            var selectedRadio=null;
            var $radios = $('.payment-info-card-details');
            $radios.each(function() {
                if ($(this).hasClass('checked')) {
                	selectedRadio=$(this);
                }
            });

            $("#hiddenSaveInAccount").val($("#saveCard").is(':checked'));
            $("#hiddenDefaultCard").val($("#defaultCard").is(':checked'));
            $("#globalMessages").html("");
            if (($("#paymentMethod_CC").val() === "CARD-SSL" || $("#paymentMethod_ALL").val() === "ALL")  && $("#payWithNewCard").hasClass('checked')) {
                ACC.worldpayLightbox.submitAjaxForm();
            } else if(selectedRadio != null || selectedRadio != undefined){
                $("#hiddenSelectedPaymentInfo").val(selectedRadio.val());
                $("#hiddenSecurityCode").val($("#securityCode").val());
                ACC.common.blockFormAndShowProcessingMessage($(this));
                $(".wpBillingAddress").filter(":hidden").remove();
                ACC.worldpay.enableAddressForm();
                if(ACC.worldpayLightbox.savedCardHopEnabled){
                    ACC.worldpayLightbox.submitAjaxForm();
                }else{
                    $("#worldPayBillingAddressForm").submit();
                }
            }else{
                //This case is when users try to click button without selecting the any radio
                $('.submit_worldPayHopForm').attr('disabled', false);
            }
        });
    },

    initForm: function () {
        this.bindSubmitPaymentAndBillingForm();
    }
};
